import React from 'react';
import { CheckIcon } from 'lucide-react';
import { MiniCta } from '../CtaBlock';
import { forYou } from '../../data/content';
export function ForYou() {
  return <section className="bg-ink-800 px-4 py-14 sm:px-6 sm:py-20" data-id="element-142" data-mp="323w0tc46z82m">
      <div className="mx-auto max-w-3xl" data-id="element-143" data-mp="2oby09pojqki2">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.22em] text-arc-light" data-id="element-144" data-mp="2t9r2k7mqaud2">
          È per te?
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-bone sm:text-4xl" data-id="element-145" data-mp="3h0dbe14k4io4">
          Il Sistema Maestro di Saldatura™ è stato creato per te se…
        </h2>

        <ul className="mt-8 space-y-2.5" data-id="element-146" data-mp="370cne1vqtedl">
          {forYou.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-ink-500 bg-ink-700 px-4 py-3.5" data-id="element-147" data-mp="3bzftzqrdfsno">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-arc" data-id="element-148" data-mp="1vobvwf7hvbu5">
                <CheckIcon className="h-3.5 w-3.5 text-ink-900" aria-hidden="true" data-id="element-149" data-mp="3p9kauie19mbb" />
              </span>
              <span className="text-[15px] leading-snug text-bone/90" data-id="element-150" data-mp="3l88g5ygayaw9">{item}</span>
            </li>)}
        </ul>

        <p className="mt-7 text-center text-base font-semibold text-bone sm:text-lg" data-id="element-151" data-mp="32lzdera46q9">
          Se ti sei riconosciuto in uno di questi punti, questo sistema è stato creato per te.
        </p>

        <MiniCta label="Sì, è per me — voglio accedere" data-id="element-152" data-mp="c28r18u7hy64" />
      </div>
    </section>;
}